import { useEffect } from "react";

const SITE_NAME = "The Safety Quest";
const DEFAULT_IMAGE = "https://static.prod-images.emergentagent.com/jobs/12617115-629c-4e84-b30d-6aab8c7efdde/images/48e2765b4ca50bebafd325d14335dad0619ccb2400dc4a646a01340c1bd1c892.png";

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export function useSEO({ title, description, image, noindex = false }) {
  useEffect(() => {
    const fullTitle = title ? `${title} · ${SITE_NAME}` : `${SITE_NAME} — Children's Safety Education`;
    const desc = description || "Teaching kids fire safety, seat belt safety, crosswalk safety and emergency preparedness through books, music and animated cartoons with Bobby and Pluggy.";
    const url = window.location.href.split("#")[0];
    const img = image || DEFAULT_IMAGE;

    document.title = fullTitle;
    setMeta("name", "description", desc);
    setMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow");
    setLink("canonical", url);

    // Open Graph
    setMeta("property", "og:type", "website");
    setMeta("property", "og:site_name", SITE_NAME);
    setMeta("property", "og:title", fullTitle);
    setMeta("property", "og:description", desc);
    setMeta("property", "og:url", url);
    setMeta("property", "og:image", img);

    // Twitter
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", fullTitle);
    setMeta("name", "twitter:description", desc);
    setMeta("name", "twitter:image", img);
  }, [title, description, image, noindex]);
}
